import { render, staticRenderFns } from "./CloseTransIcon.vue?vue&type=template&id=1bb4d8ff"
import script from "./CloseTransIcon.vue?vue&type=script&lang=js"
export * from "./CloseTransIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports